import { initSBVRPermissions } from '@/core/shared/setup/permissions';
import store from '@/core/store';

const watchForOrg = async () => {
  await new Promise(resolve => {
    const unwatch = store.watch(
      (state, getters) => getters.currentStation,
      ({ organization }) => {
        if (organization) {
          unwatch();
          resolve();
        }
      },
    );
  });

  initSBVRPermissions(
    undefined,
    store.getters.currentStation.organization,
  );
};

watchForOrg();
